module.exports = __webpack_public_path__ + "img/label_rouge.18a677f7.png";